const TAG_FOLLOW_REQUEST = 'insert-following/tag-request'
const TAG_FOLLOW_SUCCESS = 'insert-following/tag-success'
const TAG_FOLLOW_FAILURE = 'insert-following/tag-failure'

const TAG_UNFOLLOW_REQUEST = 'delete-following/tag-request'
const TAG_UNFOLLOW_SUCCESS = 'delete-following/tag-success'
const TAG_UNFOLLOW_FAILURE = 'delete-following/tag-failure'

const markUpdating = ({ opts: tag }, map) => {
  let t = map[tag]
  if (t) {
    t.updating = true
  } else {
    map[tag] = {
      _id: tag,
      updating: true
    }
  }
  return map
}

const markFollowed = ({ opts: tag }, map) => {
  map[tag].updating = false
  map[tag].following = true
  return map
}

const markUnfollowed = ({ opts: tag }, map) => {
  map[tag].updating = false
  map[tag].following = false
  return map
}

const markError = ({ opts: tag, error }, map) => {
  map[tag].updating = false
  map[tag].error = error
  return map
}

const following_tags = (state = {}, action = {}) => {
  switch (action.type) {
    case TAG_FOLLOW_REQUEST:
      state = {
        map: state.map ? markUpdating(action.payload, state.map) : undefined,
        list: state.list
      }
      break
    case TAG_FOLLOW_SUCCESS:
      state = {
        map: state.map ? markFollowed(action.payload, state.map) : undefined,
        list: state.list
      }
      break
    case TAG_FOLLOW_FAILURE:
      state = {
        map: state.map ? markError(action.payload, state.map) : undefined,
        list: state.list
      }
      break
    case TAG_UNFOLLOW_REQUEST:
      state = {
        map: state.map ? markUpdating(action.payload, state.map) : undefined,
        list: state.list
      }
      break
    case TAG_UNFOLLOW_SUCCESS:
      state = {
        map: state.map ? markUnfollowed(action.payload, state.map) : undefined,
        list: state.list
      }
      break
    case TAG_UNFOLLOW_FAILURE:
      state = {
        map: state.map ? markError(action.payload, state.map) : undefined,
        list: state.list
      }
      break
  }
  return state
}

export default following_tags
